<template>
	<div>
		<headinfo></headinfo>
		<!--中间内容-->
		<div class="center container">
			<div class="center-nav">
				<span class="hidden-xs">您的位置：</span>
				<router-link :to="{name:'home'}">首页</router-link><i>&gt;</i>
				<a title="公证动态" href="#">公证动态</a>
			</div>
			<div class="center-container">
				<div class="center-container-left">
					<div class="center-container-left-Ltitle">
						<ul>
							<li>
								<a class="active" title="工作动态" @click="show('1')">工作动态</a>
							</li>
							<li>
								<a class="active" title="通知公告" @click="show('2')">通知公告</a>
							</li>
						</ul>
						<div class="left-pic">
							<img src="./../assets/img/left-pic.png" alt="">
						</div>
					</div>
				</div>
				<!-- 工作动态 -->
				<div class="center-container-right" v-if="pages=='1'">
					<div class="center-container-right-title">
						<span class="title">工作动态</span>
					</div>
					<div class="center-container-right-words">
						<ul>
							<li v-for="(item,index) in tabledata" :key="index">
								<span class="gzdt-time">[{{item.publishTime}}]</span>
								<router-link target="_blank" :to="{name:'details',params:{type:'news',id:item.id}}">{{item.title}}</router-link>
							</li>
						</ul>
						<div class="pagearea">
							<div id="kkpager">
								<div>
									<span>共{{total}}条记录 第{{query.pageNum}}页</span> &nbsp;
									<a disabled="disabled" @click="openpagesize(1)">首页</a>
									<a disabled="disabled" @click="openpagesize(2)">上一页</a>&nbsp;
									<a disabled="disabled" @click="openpagesize(3)">下一页</a>
									<a disabled="disabled" @click="openpagesize(4)">尾页</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 通知公告 -->
				<div class="center-container-right" v-if="pages=='2'">
					<div class="center-container-right-title">
						<span class="title">通知公告</span>
					</div>
					<div class="center-container-right-words">
						<ul>
							<li v-for="(item,index) in tabledata" :key="index">
								<span class="gzdt-time">[{{item.publishTime}}]</span>
								<router-link target="_blank" :to="{name:'details',params:{type:'notify',id:item.id}}">{{item.title}}</router-link>
							</li>
						</ul>
						<div class="pagearea">
							<div id="kkpager">
								<div>
									<span>共{{total}}条记录 第{{query.pageNum}}页</span> &nbsp;
									<a disabled="disabled" @click="openpagesize(1)">首页</a>
									<a disabled="disabled" @click="openpagesize(2)">上一页</a>&nbsp;
									<a disabled="disabled" @click="openpagesize(3)">下一页</a>
									<a disabled="disabled" @click="openpagesize(4)">尾页</a>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {
		getNewsList,
		getNotifyList
	} from '../api/index.js';
	export default {
		name: "Bossspeak",
		components: {
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '公证动态-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '公证动态'
			}],
		},
		data() {
			return {
				pages: '1',
				tabledata:null,
				total:0,
				query:{
					pageNum: 1,
					pageSize: 10
				}
			}
		},
		created() {
			this.$nextTick(()=>{
				this.pages = this.$route.params.page;
				if(this.pages == '1'){
					this.getnewsinfo();
				}else{
					this.getnotifyinfo();
				}
			})
		},
		methods: {
			show(row){
				this.pages = row;
				this.query = {
					pageNum: 1,
					pageSize: 10
				};
				if(this.pages == '1'){
					this.getnewsinfo();
				}else{
					this.getnotifyinfo();
				}
			},
			getnewsinfo(){
				getNewsList(this.query).then(res=>{
					this.tabledata = res.rows
					this.total = res.total
				})
			},
			getnotifyinfo(){
				getNotifyList(this.query).then(res=>{
					this.tabledata = res.rows
					this.total = res.total
				})
			},
			openpagesize(row){
				if(row == 1){
					this.query.pageNum = row
				}else if(row == 2){
					if(this.query.pageNum > 1){
						this.query.pageNum -= 1
					}
				}else if(row == 3){
					if(parseInt(this.total / 10 + 1) > this.query.pageNum){
						this.query.pageNum += 1
					}
				}else{
					this.query.pageNum = this.total / 10 <= 0 ? 1:parseInt(this.total / 10 + 1)
				}
				if(this.pages == '1'){
					this.getnewsinfo();
				}else{
					this.getnotifyinfo();
				}
			}
		},
		// 监听路由
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.pages = val.params.page;
					if(this.pages == '1'){
						this.getnewsinfo();
					}else{
						this.getnotifyinfo();
					}
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
</style>
